query ScoreData(
	$unitIdFilter: ConditionString
	$environmentFilter: ConditionString
	$calculationDateFrom: ConditionDateTime
	$calculationDateTo: ConditionDateTime
	$timeframeDaysFilter: ConditionInt
) {
	score_web_products(
		limit: 500
		unit_id_eq: $unitIdFilter
		environment_eq: $environmentFilter
		calculation_date_ge: $calculationDateFrom
		calculation_date_le: $calculationDateTo
		timeframe_days_eq: $timeframeDaysFilter
	) {
		calculation_date
		created_at
		unit_id
		environment
		score
		timeframe_days
		unique_issues
	}
}